'use strict';

var _defineProperty = require("/opt/build/repo/www/node_modules/@babel/runtime/helpers/defineProperty");

var _require = require('./symbols'),
    func = _require.func;

var numberPredicates = _defineProperty({
  positive: function positive(value) {
    return value > 0;
  },
  negative: function negative(value) {
    return value < 0;
  },
  nonNegative: function nonNegative(value) {
    return value >= 0;
  },
  integer: function integer(value) {
    return value === (value | 0);
  }
}, func, {
  is: function is(fn) {
    return fn;
  },
  eq: function eq(v) {
    return function (value) {
      return value === v;
    };
  },
  gt: function gt(v) {
    return function (value) {
      return value > v;
    };
  },
  gte: function gte(v) {
    return function (value) {
      return value >= v;
    };
  },
  lt: function lt(v) {
    return function (value) {
      return value < v;
    };
  },
  lte: function lte(v) {
    return function (value) {
      return value <= v;
    };
  }
});

module.exports = {
  predicates: numberPredicates,
  validator: function validator(value) {
    return typeof value === 'number';
  }
};